import React, {
  ButtonHTMLAttributes,
  PropsWithChildren,
  forwardRef,
} from 'react';
import ClipLoader from 'react-spinners/ClipLoader';
import { VariantProps } from 'tailwind-variants';
import { IsVisible } from '../utils';
import { buttonStyle } from './styles';

export interface IButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonStyle> {
  hideDisabledStyle?: boolean;
  isLoading?: boolean;
  loaderColor?: string;
  style?: React.CSSProperties;
}

export const Button = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<IButtonProps>
>(
  (
    {
      bold,
      children,
      className,
      design,
      disabled = false,
      fontWeight,
      hideDisabledStyle = false,
      isLoading = false,
      italic,
      loaderColor = '#FFF',
      size,
      style,
      textTransform,
      type = 'button',
      underline,
      ...rest
    },
    ref,
  ) => (
    <button
      className={buttonStyle({
        bold,
        italic,
        underline,
        design,
        fontWeight,
        size,
        disabled: disabled && !hideDisabledStyle,
        textTransform,
        className,
      })}
      disabled={disabled || isLoading}
      ref={ref}
      style={style}
      type={type}
      {...rest}
    >
      <IsVisible when={!isLoading}>{children}</IsVisible>
      <IsVisible when={isLoading}>
        <ClipLoader color={loaderColor} size={20} />
      </IsVisible>
    </button>
  ),
);

Button.displayName = 'Button';
